module.exports = __webpack_public_path__ + "static/media/success.04eb225b.jpg";